module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-28.c578f579.png";